<template>
	<transition name="fade" v-if="config.show">
		<div class="modal-box">
			<div class="modal modal-lg p-0">
				<div class="modal-header clearfix">
					<h2 class="pull-left">
						콘텐츠 등록
					</h2>
					<a  class="close" @click="config.show = false">&times;</a>
				</div>
				<!-- //end .modal-header -->
				<div class="modal-body p-10 clearfix">
					<div class="send-search-box pull-right m-t-10 m-b-15 clearfix" style="width: calc(100% - 260px);">
						<div class="sitemap">
							<a >CMS</a> &gt; <a >1depth</a> &gt; <a >2depth</a> &gt; <a
								>3depth</a>
						</div>
					</div>
					<!-- //end .send-search-box -->
					<div class="w240 pull-left b-r">
						<nav class="modal-depth">
							<ul class="depth clearfix">
								<li class="depth-0 open">
									cms
								</li>
								<li class="depth-1 open">
									cms
								</li>
								<li class="depth-2">
									cms
								</li>
								<li class="depth-2 open">
									cms
								</li>
								<li class="depth-3 open">
									cms
								</li>
								<li class="depth-4 open">
									cms
								</li>
								<li class="depth-5 on">
									cms
								</li>
							</ul>
						</nav>
						<!-- //end .modal-depth -->
					</div>
					<table class="cms-table table2 table-hover m-t-10 text-left">
						<colgroup>
							<col width="50%">
							<col width="">
							<col width="">
							<col width="">
						</colgroup>
						<thead>
							<tr class="f-14">
								<td class="text-left">
									<a class="text-darkgray">이름</a>
								</td>
								<td class="text-left">
									속성
								</td>
								<td class="text-left">
									<a class="text-darkgray">크기</a>
								</td>
								<td class="text-left">
									<a class="text-darkgray">생성날짜</a>
								</td>
							</tr>
						</thead>
						<tbody v-if="path!='/'">
							<tr class="margin">
								<td colspan="4"></td>
							</tr>
							<tr @dblclick="refresh(path.replace(path.split('/')[path.split('/').length-1],''))">
								<td>
									<img src="images/folder.png" width="18" alt="">
									&nbsp;
									<span>[상위 폴더로 이동]</span>
								</td>
								<td></td>
								<td></td>
								<td></td>
							</tr>
						</tbody>
						<tbody v-for="(file, index) in files" :key="'cms-files-'+hash(file)" :item="file" :index="index">
							<tr class="margin">
								<td colspan="4"></td>
							</tr>
							<tr @dblclick="refresh(file.attr=='dir'?file.path:null)" @click="selectedFile=file">
								<td>
									<img src="images/folder.png" width="18" alt="">
									&nbsp;
									<span>{{file.name}}</span>
								</td>
								<td>{{(file.attr=='dir'?'폴더':(file.attr=='normal'?file.ext:file.attr))}}</td>
								<td>{{file.size}}</td>
								<td>{{file.regDate}} ({{file.user}})</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- //end .modal-body -->
				<div class="modal-footer p-10 text-center b-t">
					<span v-if="selectedFile">/{{ selectedFile.path }} 선택됨</span>
					<button class="btn bg-deepblue text-white round" type="button" @click="register">등록</button>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import server from '../statics/server.js'
import axios from 'axios'
import moment from 'moment'

export default {
	name: "ModalClassContentsRegister",

	default: function() {
		return {
			name: this.name,
			show: false,
			lesGrpIdx: -1,
			lesId: 0,
			isModifying: false,
			fieldName: ""
		}
	},

	mounted: function() {
		this.refresh();
		this.getTree();
	},

	data: function() {
		return  {
			path: "/",
			tree: [],
			files: [],
			selectedFile: null
		}
	},

	props: {
		config: Object
	},

	methods: {
		// 파일목록 조회
		refresh: function(path) {
			if(path) this.path = path[0]=='/'?path:'/'+path;
			// 현재 디렉토리의 내용을 열거한다.
			axios.get(server.cms()+"/cms"+this.path+"?files=true").then( (result) => {
				if(result.status==200) {
					this.files = result.data.files.map((f)=>{f.checked=false;f.regDate=moment(f.regDate).format("YYYY-MM-DD HH:mm:ss");f.depth_=this.path.split("/").length-1;f.opened_=false;return f;});
				} else {
					// eslint-disable-next-line
					console.log("서버에서 비정상 응답", result);
				}
			}).catch( (response) => {
				// eslint-disable-next-line
				console.log("통신 실패", response);
			})
		},
		// 콘텐츠 선택완료
		register: function() {
			if(!this.selectedFile) {
				// eslint-disable-next-line
				console.log("파일이 선택되지 않음");
			}
			this.$emit("selected", "/"+this.selectedFile.path, this.selectedFile.size);
			this.config.show = false;
		},
		// 트리 만들기
		getTree: function(parent) {
			let addr = server.cms()+"/cms/";
			if(parent) {
				addr += parent.path;
			}
			axios.get(addr+"?files=true&dirs=true").then( (response) => {
				// eslint-disable-next-line
				console.log("CMS 폴더트리 그리기 응답", response);
			});
		}
	}
}
</script>
